export default __webpack_public_path__ + "static/media/serviceRequestActive.5440a5f9.svg";